import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Cerca o modal de detalhes.
 *
 * Um TypeError dentro de um `useMemo` derruba a árvore React inteira e o
 * sistema vira tela branca — aconteceu em 23/09 abrindo o grupo 2185, cujo
 * `error_map` está no formato antigo. O dado bruto vem do banco e tem anos de
 * formatos diferentes; nenhum deles pode custar a aplicação toda.
 *
 * Aqui o pior caso é o modal não abrir, com uma saída visível.
 */
interface Props { children: ReactNode; onClose: () => void }
interface State { erro: Error | null }

export class ModalErrorBoundary extends Component<Props, State> {
  state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error('[BroadcastDetailsModal] quebrou ao renderizar', erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;

    return (
      <div
        style={{
          position: 'fixed', inset: 0, zIndex: 60, display: 'flex',
          alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,.45)',
        }}
        onClick={this.props.onClose}
      >
        <div
          style={{
            background: '#fff', borderRadius: 12, padding: '28px 32px',
            maxWidth: 460, textAlign: 'center', font: '14px/1.5 system-ui, sans-serif',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <p style={{ fontWeight: 600, marginBottom: 8 }}>Não consegui montar o detalhe deste disparo</p>
          <p style={{ color: '#6b7280', marginBottom: 16 }}>
            O restante do sistema segue funcionando. O erro está no console.
          </p>
          <button
            type="button"
            onClick={this.props.onClose}
            style={{
              border: '1px solid #d1d5db', background: '#fff', borderRadius: 8,
              padding: '6px 16px', font: 'inherit', cursor: 'pointer',
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    );
  }
}
